import { render, staticRenderFns } from "./pledge-selector.vue?vue&type=template&id=c8491a8a&scoped=true"
import script from "./pledge-selector.vue?vue&type=script&lang=ts"
export * from "./pledge-selector.vue?vue&type=script&lang=ts"
import style0 from "./pledge-selector.vue?vue&type=style&index=0&id=c8491a8a&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8491a8a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/usr/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c8491a8a')) {
      api.createRecord('c8491a8a', component.options)
    } else {
      api.reload('c8491a8a', component.options)
    }
    module.hot.accept("./pledge-selector.vue?vue&type=template&id=c8491a8a&scoped=true", function () {
      api.rerender('c8491a8a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/shared/components/payment-form/pledge-selector/pledge-selector.vue"
export default component.exports